import { render, staticRenderFns } from "./CurrentGoal.vue?vue&type=template&id=8e535ea6&scoped=true&"
import script from "./CurrentGoal.vue?vue&type=script&lang=ts&"
export * from "./CurrentGoal.vue?vue&type=script&lang=ts&"
import style0 from "./CurrentGoal.vue?vue&type=style&index=0&id=8e535ea6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e535ea6",
  null
  
)

export default component.exports